import { defineComponent as l, watch as m, renderSlot as a } from "vue";
import { provideGlobalConfig as s } from "./index620.js";
import { configProviderProps as u } from "./index621.js";
const d = {
  placement: "top"
};
l({
  name: "ElConfigProvider",
  props: u,
  setup(o, { slots: t }) {
    const e = s(o);
    return m(
      () => o.message,
      (n) => {
        var r, i;
        Object.assign(d, (i = (r = e?.value) == null ? void 0 : r.message) != null ? i : {}, n ?? {});
      },
      { immediate: !0, deep: !0 }
    ), () => a(t, "default", { config: e?.value });
  }
});
export {
  d as messageConfig
};
